import React, { useEffect, useState } from "react";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  DatePicker,
  Drawer,
  Empty,
  Spin,
  Divider,
  Select as TagSelector,
  Input,
} from "antd";
import dayjs from "dayjs";
import PropTypes from "prop-types";
// import { CalendarOutlined } from "@ant-design/icons";
// import { CloseOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end", // or "top", "bottom-end", etc.
  showConfirmButton: false,
  timer: 2500,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});
const Reminders = ({ recordId, type, open, onClose }) => {
  console.log(onClose);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  console.log(userId);

  const [reminders, setReminders] = useState([]);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [addReminderLoading, setAddReminderLoading] = useState(false);
  const [updateReminderLoading, setUpdateReminderLoading] = useState(false);

  const [editingReminderId, setEditingReminderId] = useState(null);

  const [reminderData, setReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
  });

  const [editReminderData, setEditReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
    isnotified: 0,
  });

  const [staffList, setStaffList] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);

  const relTypeMap = {
    proposal: "Proposal",
    estimate: "Estimate",
    invoice: "Invoice",
    creditnote: "CreditNote",
  };

  const relType = relTypeMap[type];

  const fetchReminders = async () => {
    try {
      setRemindersLoading(true);

      if (!recordId || !relType) {
        console.error("Invalid recordId or type");
        setReminders([]);
        return;
      }

      const response = await fetch(
        `${BASE_CRM_URL}reminder/GetReminders?rel_id=${recordId}&rel_type=${relType}&staffid=0`,
      );

      const data = await response.json();

      if (data.Status) {
        setReminders(data.ResultData || []);
      } else {
        setReminders([]);
      }
    } catch (error) {
      console.error("Error fetching reminders:", error);
      setReminders([]);
    } finally {
      setRemindersLoading(false);
    }
  };

  const fetchStaff = async () => {
    try {
      setStaffLoading(true);

      const response = await fetch(`${BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.ResultData) {
        setStaffList(data.ResultData);
      } else {
        setStaffList([]);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaffList([]);
    } finally {
      setStaffLoading(false);
    }
  };
  const handleAddReminder = async () => {
    if (!reminderData.description.trim()) {
      Toast.fire({
        icon: "warning",
        title: "Please enter reminder description.",
      });

      return;
    }

    if (!reminderData.date) {
      Toast.fire({ icon: "warning", title: "Please select reminder date." });

      return;
    }

    if (!recordId || !relType) {
      Toast.fire({
        icon: "warning",
        title: "Invalid record or reminder type.",
      });

      return;
    }

    try {
      setAddReminderLoading(true);

      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));

      const userId = userDetails?.staffid;

      const response = await fetch(`${BASE_CRM_URL}reminder/AddReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          description: reminderData.description,
          date: dayjs(reminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          rel_id: recordId,
          rel_type: relType,
          staff: reminderData.staff,
          creator: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Toast.fire({
          icon: "success",
          title: "Reminder added.",
        });

        setReminderData({
          description: "",
          date: null,
          staff: userId,
        });

        window.dispatchEvent(new Event("refresh-notifications"));

        await fetchReminders();

        // Close ONLY after API succeeds
        // if (closeAfterSave) {
        //   handleCloseReminderDrawer();
        // }
      } else {
        Toast.fire({
          icon: "error",
          title: data.Message || "Failed to add reminder.",
        });
      }
    } catch (error) {
      console.error("Error adding reminder:", error);

      Toast.fire({
        icon: "error",
        title: "Something went wrong",
      });
    } finally {
      setAddReminderLoading(false);
    }
  };

  const handleEditReminder = (reminder) => {
    setEditingReminderId(reminder.id);

    setEditReminderData({
      description: reminder.description,
      date: dayjs(reminder.date),
      staff: reminder.staff,
      isnotified: Number(reminder.isnotified) === 1 ? 1 : 0,
    });
  };

  const handleCancelReminderEdit = () => {
    setEditingReminderId(null);

    setEditReminderData({
      description: "",
      date: null,
      staff: userId,
      isnotified: 0,
    });
  };

  const handleUpdateReminder = async () => {
    if (!editReminderData.description.trim()) {
      Toast.fire({
        icon: "warning",
        title: "Please enter reminder description.",
      });

      return;
    }

    if (!editReminderData.date) {
      Toast.fire({ icon: "warning", title: "Please select reminder date." });

      return;
    }

    try {
      setUpdateReminderLoading(true);

      const response = await fetch(`${BASE_CRM_URL}reminder/UpdateReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingReminderId,
          description: editReminderData.description,
          date: dayjs(editReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          staff: editReminderData.staff,
          isnotified: Number(editReminderData.isnotified),
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Toast.fire({
          icon: "success",
          title: "Reminder Updated.",
        });

        setEditingReminderId(null);

        fetchReminders();
      } else {
        Toast.fire({
          icon: "error",
          title: "Failed to update reminder.",
        });
      }
    } catch (error) {
      console.error(error);

      Toast.fire({
        icon: "error",
        title: "Something went wrong ",
      });
    } finally {
      setUpdateReminderLoading(false);
    }
  };

  useEffect(() => {
    fetchReminders();
    fetchStaff();
  }, []);

  useEffect(() => {
    if (recordId && relType) {
      fetchReminders();
    }
  }, [recordId, type]);

  const handleCloseReminderDrawer = () => {
    setEditingReminderId(null);

    setReminderData({
      description: "",
      date: null,
      staff: null,
    });

    setEditReminderData({
      description: "",
      date: null,
      staff: null,
    });
    onClose();
  };

  const handleDeleteReminder = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this reminder?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e40d22",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await fetch(`${BASE_CRM_URL}reminder/DeleteReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
        }),
      });

      const data = await response.json();

      if (data.Status || data.status) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: data.message || "Reminder deleted successfully.",
          timer: 1500,
          showConfirmButton: false,
        });

        // Refresh reminder list
        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Failed to delete reminder.",
        });
      }
    } catch (error) {
      console.error("Delete reminder error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while deleting the reminder.",
      });
    }
  };

  return (
    <>
      <Drawer
        title="Reminders"
        open={open}
        onClose={handleCloseReminderDrawer}
        width={550}
        destroyOnClose
        maskClosable={true}
        closable={false}
        extra={
          // <Button
          //   type="text"
          //   icon={<CloseOutlined />}
          //   onClick={handleCloseReminderDrawer}
          // />
          <div className="d-flex justify-content-end gap-2">
            {/* <Button type="text" icon={<CloseOutlined />} onClick={onClose} /> */}

            <button
              type="button"
              onClick={handleCloseReminderDrawer}
              disabled={addReminderLoading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#e40d22",
                color: "#fff",
                border: "none",
              }}
              title="Close"
            >
              <i className="fa fa-times" />
            </button>

            <button
              type="button"
              onClick={handleAddReminder}
              disabled={addReminderLoading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#07f083",
                color: "#fff",
                border: "none",
              }}
              title="Save"
            >
              {addReminderLoading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                />
              ) : (
                <i className="fa fa-check" />
              )}
            </button>
          </div>
        }
      >
        {/* Add / Edit Form */}

        {editingReminderId === null ? (
          <>
            <Input.TextArea
              rows={3}
              placeholder="Reminder description"
              value={reminderData.description}
              onChange={(e) =>
                setReminderData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />

            <div className="row mt-3">
              <div className="col-md-6">
                <DatePicker
                  showTime
                  className="w-100"
                  value={reminderData.date}
                  onChange={(value) =>
                    setReminderData((prev) => ({
                      ...prev,
                      date: value,
                    }))
                  }
                />
              </div>

              <div className="col-md-6">
                <TagSelector
                  className="w-100"
                  style={{ height: 38 }}
                  placeholder="Select Staff"
                  loading={staffLoading}
                  value={reminderData.staff}
                  onChange={(value) =>
                    setReminderData((prev) => ({
                      ...prev,
                      staff: value,
                    }))
                  }
                  options={staffList.map((staff) => ({
                    value: staff.staffid,
                    label: `${staff.firstname} ${staff.lastname}`,
                  }))}
                />
              </div>
            </div>

            <div className="text-end mt-3">
              {/* <Button
                type="primary"
                loading={addReminderLoading}
                onClick={() => handleAddReminder(false)}
              >
                Save
              </Button> */}

              {/* <Button
                type="primary"
                className="ms-2"
                loading={addReminderLoading}
                onClick={() => handleAddReminder(true)}
              >
                Save & Close
              </Button> */}
            </div>
          </>
        ) : (
          <>
            {/* Edit Form */}
            <Input.TextArea
              rows={3}
              value={editReminderData.description}
              onChange={(e) =>
                setEditReminderData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
            <div className="row mt-3">
              <div className="col-md-6">
                <DatePicker
                  showTime
                  className="w-100 mt-3"
                  value={editReminderData.date}
                  onChange={(value) =>
                    setEditReminderData((prev) => ({
                      ...prev,
                      date: value,
                    }))
                  }
                />
              </div>
              <div className="col-md-6">
                <TagSelector
                  className="w-100 mt-3"
                  style={{ height: 38 }}
                  value={editReminderData.staff}
                  onChange={(value) =>
                    setEditReminderData((prev) => ({
                      ...prev,
                      staff: value,
                    }))
                  }
                  options={staffList.map((staff) => ({
                    value: staff.staffid,
                    label: `${staff.firstname} ${staff.lastname}`,
                  }))}
                />
              </div>
              <div className="col-md-6">
                <TagSelector
                  className="w-100 mt-3"
                  style={{ height: 38 }}
                  value={editReminderData.isnotified}
                  onChange={(value) =>
                    setEditReminderData((prev) => ({
                      ...prev,
                      isnotified: Number(value),
                    }))
                  }
                  options={[
                    {
                      value: 1,
                      label: <span>Completed</span>,
                    },
                    {
                      value: 0,
                      label: <span>Pending</span>,
                    },
                  ]}
                />
              </div>
            </div>
            <div className="text-end mt-3">
              <Button className="me-2" onClick={handleCancelReminderEdit}>
                Cancel
              </Button>

              <Button
                type="primary"
                loading={updateReminderLoading}
                onClick={handleUpdateReminder}
              >
                Update
              </Button>
            </div>
          </>
        )}

        <Divider>Reminder List</Divider>

        {remindersLoading ? (
          <div className="text-center py-4">
            <Spin />
          </div>
        ) : reminders.length > 0 ? (
          reminders.map((reminder) => {
            const isCompleted = Number(reminder.isnotified) === 1;

            return (
              <Card key={reminder.id} size="small" className="mb-3 shadow">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div>{reminder.description}</div>

                    <div className="d-flex align-items-center gap-3 text-muted mt-2">
                      <small>
                        <i className="fa fa-user me-2"></i>
                        {reminder.firstname} {reminder.lastname}
                      </small>

                      <small>
                        <i className="fa fa-calendar me-2"></i>
                        {dayjs(reminder.date).format("DD-MM-YYYY hh:mm A")}
                      </small>
                      <div className="">
                        <span
                          className={`badge ${
                            isCompleted
                              ? "bg-success-subtle text-success"
                              : "bg-danger-subtle text-danger"
                          }`}
                          style={{
                            borderRadius: "8px",
                            padding: "5px 10px",
                            fontSize: "12px",
                            fontWeight: 600,
                          }}
                        >
                          {isCompleted ? "Completed" : "Pending"}
                        </span>
                      </div>
                    </div>

                    {/* Status Badge */}
                  </div>
                  <div className="d-flext justift-content-between gap-2">
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      onClick={() => handleEditReminder(reminder)}
                    />
                    <Button
                      type="text"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => handleDeleteReminder(reminder.id)}
                    />
                  </div>
                </div>
              </Card>
            );
          })
        ) : (
          <Empty description="No reminders found" />
        )}
      </Drawer>
    </>
  );
};
Reminders.propTypes = {
  recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Reminders;
